<template>
    <div
        v-if="submission.paletteId"
        class="Report__group-field-wrapper"
    >
        <div class="Report__field__submission">
            <v-text-field
                type="text"
                readonly
                label="Color Scheme"
                v-model="palette.name"
                dense
                outlined
            />
        </div>

        <div
            class="Report__field__submission"
            v-if="palette.color_1"
        >
            <v-text-field
                type="text"
                readonly
                label="Color 1"
                v-model="palette.color_1"
                dense
                outlined
            />
            <div
                class="Report__color-swatch"
                :style="'background-color:' + palette.color_1"
            />
            <v-btn
                icon
                small
                type="button"
                color="primary"
                v-clipboard="palette.color_1.slice(1)"
            >
                <v-icon small>
                    fas fa-copy
                </v-icon>
            </v-btn>
        </div>

        <div
            class="Report__field__submission"
            v-if="palette.color_2"
        >
            <v-text-field
                type="text"
                readonly
                label="Color 2"
                v-model="palette.color_2"
                dense
                outlined
            />
            <div
                class="Report__color-swatch"
                :style="'background-color:' + palette.color_2"
            />
            <v-btn
                icon
                small
                type="button"
                color="primary"
                v-clipboard="palette.color_2.slice(1)"
            >
                <v-icon small>
                    fas fa-copy
                </v-icon>
            </v-btn>
        </div>

        <div
            class="Report__field__submission"
            v-if="palette.color_3"
        >
            <v-text-field
                type="text"
                readonly
                label="Color 3"
                v-model="palette.color_3"
                dense
                outlined
            />
            <div
                class="Report__color-swatch"
                :style="'background-color:' + palette.color_3"
            />
            <v-btn
                icon
                small
                type="button"
                color="primary"
                v-clipboard="palette.color_3.slice(1)"
            >
                <v-icon small>
                    fas fa-copy
                </v-icon>
            </v-btn>
        </div>
    </div>

    <div
        v-else
        class="Report__group-field-wrapper"
    >
        <div class="Report__field__submission">
            <v-text-field
                type="text"
                readonly
                label="Color Scheme"
                v-model="customTitle"
                dense
                outlined
            />
        </div>

        <div
            class="Report__field__submission"
            v-if="submission.customPalette"
        >
            <v-text-field
                type="text"
                readonly
                label="Color 1"
                v-model="submission.customPalette.color_1"
                dense
                outlined
            />
            <div
                class="Report__color-swatch"
                :style="'background-color:' + submission.customPalette.color_1"
            />
            <v-btn
                icon
                small
                type="button"
                color="primary"
                v-clipboard="submission.customPalette.color_1.slice(1)"
            >
                <v-icon small>
                    fas fa-copy
                </v-icon>
            </v-btn>
        </div>

        <div
            class="Report__field__submission"
            v-if="submission.customPalette"
        >
            <v-text-field
                type="text"
                readonly
                label="Color 2"
                v-model="submission.customPalette.color_2"
                dense
                outlined
            />
            <div
                class="Report__color-swatch"
                :style="'background-color:' + submission.customPalette.color_2"
            />
            <v-btn
                icon
                small
                type="button"
                color="primary"
                v-clipboard="submission.customPalette.color_2.slice(1)"
            >
                <v-icon small>
                    fas fa-copy
                </v-icon>
            </v-btn>
        </div>

        <div
            class="Report__field__submission"
            v-if="submission.customPalette"
        >
            <v-text-field
                type="text"
                readonly
                label="Color 3"
                v-model="submission.customPalette.color_3"
                dense
                outlined
            />
            <div
                class="Report__color-swatch"
                :style="'background-color:' + submission.customPalette.color_3"
            />
            <v-btn
                icon
                small
                type="button"
                color="primary"
                v-clipboard="submission.customPalette.color_3.slice(1)"
            >
                <v-icon small>
                    fas fa-copy
                </v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import ReportFieldBoilerplate from '@/reports/Fields/Common/ReportFieldBoilerplate';
import axios from 'axios';

export default {
    mixins: [
        ReportFieldBoilerplate,
    ],

    data() {
        return {
            palette: [],
            customTitle: 'Custom Color Scheme',
        };
    },

    mounted() {
        if (this.submission.paletteId) {
            this.getPaletteById();
        }
    },

    methods: {
        getPaletteById() {
            axios.get('/api/palette/preview/' + this.submission.paletteId)
                .then(response => {
                    this.palette = response.data.data.palette;
                });
        }
    }
};
</script>
<style lang="scss">
.Report__color-swatch {
    flex: 0 0 30px;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    margin-top: -1px;
    margin-left: 8px;
    box-shadow: 2px 2px 3px rgba(black, 0.2);
}
</style>
